import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CreateContractMohaService } from "src/app/core/services/create-contract-moha.service";
import {MatDialog} from "@angular/material";
import {WarningComponent} from "src/app/shared/components/warning/warning.component";
import {Message} from "src/app/core/class/message";
import { TranslateService } from '@ngx-translate/core';

export interface UploadedFile {
  id?: string;
  fileName: string;
  fileSize?: number;
  path?: string;
  idFileContract: string;
  uploadStatus: 'SUCCESS' | 'FAILED';
  errorMessage?: string;
}

@Component({
  selector: 'app-upload-file-digital',
  templateUrl: './upload-file-digital.component.html',
  styleUrls: ['./upload-file-digital.component.scss']
})
export class UploadFileDigitalComponent implements OnInit {
  displayedColumns: string[] = ['stt', 'fileName', 'idFileContract', 'uploadStatus', 'errorMessage', 'action'];
  uploadedFiles = new MatTableDataSource<UploadedFile>([]);


  isDragOver = false;
  private readonly MAX_FILES = 50;

  constructor(
    private translate: TranslateService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private http: HttpClient,
    private documentMohaService: DocumentMohaService,
    public createContractMohaService: CreateContractMohaService,
    public message: Message,
  ) {}

  ngOnInit(): void {}

  uploadFile() {
    const fileInput = document.getElementById('filePdf');
    if (fileInput) {
      fileInput.click();
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    const files = event.dataTransfer ? event.dataTransfer.files : null;
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  async onChangeFile(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    await this.handleFiles(files);
    
    // Clear input so same files can be selected again
    event.target.value = '';
  }

  async handleFiles(files: FileList) {
    const currentCount = this.uploadedFiles.data.length;

      // Nếu tổng số file sau khi import vượt quá 50 thì không cho import
      if (currentCount + files.length > this.MAX_FILES) {
        this.toast.error(
          this.translate.instant('digital_lot.count_file')
        );
        return;
      }

    const payloadFiles: any[] = [];
    const maxFileSize = 5 * 1024 * 1024; // 5MB

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
        this.toast.error(this.translate.instant('digital_lot.not_pdf_error', { fileName: file.name }));
        continue;
      }

      if (file.size > maxFileSize) {
        this.uploadedFiles.data = [{
          fileName: file.name,
          idFileContract: '',
          uploadStatus: 'FAILED',
          errorMessage: this.translate.instant('digital_lot.file_too_large')
        }, ...this.uploadedFiles.data];
        continue;
      }

      const base64 = await this.getBase64(file) as string;
      const base64Content = base64.split(',')[1] || base64;
      payloadFiles.push({
        fileName: file.name,
        file: base64Content
      });
    }

    if (payloadFiles.length > 0) {
      this.callUploadApi(payloadFiles);
    }
  }

  get totalSuccess(): number {
    return this.uploadedFiles.data.filter(f => f.uploadStatus === 'SUCCESS').length;
  }
  
  get totalFailed(): number {
    return this.uploadedFiles.data.filter(f => f.uploadStatus !== 'SUCCESS').length;
  }


  callUploadApi(files: any[]) {

    const payload = { files };

    this.documentMohaService.uploadFileDigital(payload).subscribe({
      next: (res: any) => {
        const data = res.data || res;
        if (data && data.files) {

          // Map danh sách file theo đúng tên đã gửi lên API
          const newFiles: UploadedFile[] = data.files.map((f: any) => ({
            id: f.id,
            fileName: f.fileName,
            fileSize: f.fileSize,
            path: f.path,
            idFileContract: f.idFileContract,
            uploadStatus: f.uploadStatus,
            errorMessage: f.errorMessage || ''
          }));

          this.uploadedFiles.data = [...newFiles, ...this.uploadedFiles.data];
        }
      },
      error: (err: any) => {
        this.toast.error(this.translate.instant('digital_lot.upload_error'));
      }
    });
  }

  getBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  deleteFile(index: number, element: UploadedFile) {
    this.removeFileFromList(index, element);
    this.toast.success(this.translate.instant('digital_lot.delete_file_success'));
  }

  private removeFileFromList(index: number, element: UploadedFile) {
    const currentData = this.uploadedFiles.data;
    const targetIndex = currentData.indexOf(element);
    const removeIdx = targetIndex !== -1 ? targetIndex : index;


    currentData.splice(removeIdx, 1);
    this.uploadedFiles.data = [...currentData];
  }

  onCancel() {
    if (this.uploadedFiles && this.uploadedFiles.data && this.uploadedFiles.data.length >= 1) {
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '40%',
        data: this.message.getMessage('messages.cancel_create_contract_lot')
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        }
      });
      return;
    }
    this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
  }
  onContinue() {
    // Lọc ra những file thành công và map dữ liệu theo form yêu cầu
    const successFiles = this.uploadedFiles.data.filter(f => f.uploadStatus === 'SUCCESS');
  if (successFiles.length === 0) {
    return;
  }

    this.createContractMohaService.listDigitalContractFiles.next(successFiles);

    // Chuyển hướng theo đúng route bạn đã dùng trong hình 1
    this.router.navigate(['/home-enterprise/contract-digital-add-lot/add-lot']);
  }

  // Hàm tạo mã ngẫu nhiên cho idFileContract
  // private generateIdFileContract(): string {
  //   const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
  //     const r = Math.random() * 16 | 0;
  //     const v = c === 'x' ? r : (r & 0x3 | 0x8);
  //     return v.toString(16);
  //   });
  //   return 'FKE_' + uuid;
  // }
}

